import { UIElement } from "../ui-element.js";
//#region src/ui/seek-indicator/value.ts
var SeekIndicatorValueElement = class extends UIElement {
	static {
		this.tagName = "media-seek-indicator-value";
	}
};
//#endregion
export { SeekIndicatorValueElement };
